import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import MaterialSpinner from "../../../../ui/materialSpinner";
import Button from "@mui/material/Button";

import {ROUTES} from "../../../../../routes";
import {
  cartItemInStock,
  filterCartItems,
} from "../../../lookNavigation/lookFunctions2";
import GroheCartStickyFooter from "../groheCartStickyFooter";
// import GroheCartBackButton from "../groheCartBackButton";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartColumns from "../groheCartColumns";
import {postShipperHQOptions, postTrumbleShippingOptions} from "../../../../../api/look-api";
import {setDeliveryList} from "../../../../../actions/shoppingCartFunctions";
import GroheCartDeliveryContent from "./groheCartDeliveryContent";
import WithCartCheckoutClick from "../../../hocs/withCartCheckoutClick";
import {restoreCart} from "../../../../../actions/actionFunctions";
import {usePrevious} from "../../../../../misc/helperHooks";
import {setCartItemsShipping} from "./deliveryFunctions";


const GroheCartDelivery = (props) => {

  const {visualizersLoadedLength, isMobile, cartItems, history, cartCheckoutClick, shippingAddress, setDeliveryList,
    restoreCart, fabricatorSettings, cartItemsTotalQuantity, cartItemsToInclude} = props;

  const [deliveriesReceived, setDeliveriesReceived] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const prevQuantity = usePrevious(cartItemsTotalQuantity);

  const backButtonClick = () => {
    history.push(ROUTES.cartConfirm);
  };

  const getTrumbleResponseShipping = async () => {
    const cartItemsString = cartItemsToInclude.map(cartItem => ({
      "dbFeatureId": cartItem.cartFeature.dbFeature.id,
      "groupName": cartItem.cartFeature.dbFeature.groupName,
      "sku": cartItem.cartFeature.dbFeature.sku || cartItem.cartFeature.dbFeature.sharedFeatureName,
      "quantity": cartItem.quantity
    }));
    const {postal} = shippingAddress;
    const availableOptions = await postTrumbleShippingOptions(cartItemsString, postal);
    console.log("availableOptions", availableOptions);
    if (availableOptions && availableOptions.success && Array.isArray(availableOptions.shipping)) {
      setDeliveryList(availableOptions.shipping);
    }
    return availableOptions.shipping
  }

  const getShippingHQResponseShipping = async () => {
    const availableOptions = await postShipperHQOptions(shippingAddress, cartItems);
    console.log("availableShipperHQOptions", availableOptions);
    if (Array.isArray(availableOptions) && availableOptions.length) {
      setDeliveryList(availableOptions);
      return availableOptions
    }
    return []
  }

  const getOptionsAndCreateDeliveryList = async () => {
    setShowLoader(true);
    let shippingOptions = [];
    if (fabricatorSettings.useShipperHQ) {
      shippingOptions = await getShippingHQResponseShipping();
    } else if (fabricatorSettings.useTrumbleApi) {
      shippingOptions = await getTrumbleResponseShipping();
    }
    const newCartItems = setCartItemsShipping(cartItems, shippingOptions);
    console.log("newCartItems with shipping", newCartItems);
    restoreCart({cartItems: newCartItems});
    setDeliveriesReceived(true);
    setShowLoader(false);
  }

  useEffect(() => {
    if (cartItemsTotalQuantity && (prevQuantity !== cartItemsTotalQuantity)) {
      getOptionsAndCreateDeliveryList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItemsTotalQuantity])

  if (visualizersLoadedLength && !cartItemsToInclude.length) {
    // if (!cartItems.length || (Object.keys(quotesList).every(quoteIndex => !quotesList[quoteIndex].length))) {
    return (
      <div className="gc-section">
        <h3 className="gc-header__sub-title text-center">
          <FormattedMessage id="grohe.cart.noCartItems"/>
        </h3>
      </div>
    )
  }

  const disabled = cartItemsToInclude.every(cartItem => !cartItemInStock(cartItem))
    || cartItemsToInclude.filter(cartItem => cartItemInStock(cartItem)).every(cartItem => !cartItem.quantity);

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: backButtonClick
    },
    {
      translate: "grohe.cart.confirm.checkoutButton",
      classes: "look-button--blue gc-sticky__button--60",
      onClick: cartCheckoutClick,
      disabled
    }
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartHeaderCommon title="grohe.cart.delivery.title" subTitle="grohe.cart.delivery.subTitle"/>
        <div className="gc-main">
          {visualizersLoadedLength && deliveriesReceived ? <GroheCartDeliveryContent/> : null}
          {showLoader ? <MaterialSpinner/> : null}
        </div>
        {isMobile ? (
          <Fragment>
            <div className="gc-spacer"/>
            {/*<div className="gc-spacer gc-spacer--small"/>*/}
          </Fragment>
        ) : (
          <footer className="gc-footer gc-footer--between">
            <div className="gc-form__submit-left">
              <GroheCartColumns/>
            </div>
            <div className="gc-form__submit-right">
              {/*<GroheCartBackButton backButtonClick={backButtonClick}/>*/}
              <Button className="look-button look-button--blue look-button--big nowrap"
                      disabled={disabled}
                      onClick={cartCheckoutClick}>
                <FormattedMessage id="grohe.cart.confirm.checkoutButton"/>
              </Button>
            </div>
          </footer>
        )}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, isMobile} = store.serverState;
  const {cartItems} = store.cartState;
  const {shippingAddress} = store.paymentState;
  const {settings} = store.fabricatorState;

  const cartItemsToInclude = filterCartItems(cartItems, true, true);
  const cartItemsTotalQuantity = cartItemsToInclude.reduce((total, cartItem) => {
    return (cartItem.partId === 'slabs') ? total : total + cartItem.quantity
  }, 0);

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    isMobile,
    cartItems,
    shippingAddress,
    fabricatorSettings: settings,
    cartItemsToInclude,
    cartItemsTotalQuantity,
  };
};

const mapDispatchToProps = {
  setDeliveryList,
  restoreCart,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithCartCheckoutClick(GroheCartDelivery))
)
